import { FormlyFieldConfig } from '@ngx-formly/core';
import type { FormlyHookFn } from './formly-hook-fn.type';
import { startWith, takeUntil } from 'rxjs/operators';

export const synchronizeHook = (
  functionName,
  synchronizedUpdates,
  destroyed$
): FormlyHookFn => {
  return (field: FormlyFieldConfig) => {
    const control = field.form.get(field.key as string);
    (field.props?.synchronizeInitialValue
      ? control.valueChanges.pipe(startWith(control.value))
      : control.valueChanges
    )
      .pipe(takeUntil(destroyed$))
      .subscribe((newVal) => {
        if (newVal != null) {
          const syncArgs = functionName.slice(1);
          const fieldName = syncArgs[0];
          if (fieldName.startsWith('applicationUDF:')) {
            const udfName = fieldName.split(':')[1];
            if (!synchronizedUpdates.applicationUDFs) {
              synchronizedUpdates.applicationUDFs = {};
            }
            synchronizedUpdates.applicationUDFs[udfName] = newVal;
          } else {
            synchronizedUpdates[fieldName] = newVal;
          }
        }
      });
  };
};
